export default __webpack_public_path__ + "static/media/TheWheelOfPain.6a6fc2a6.jpg";